// extracted by mini-css-extract-plugin
module.exports = {"content":"qp-z"};